import { Box, makeStyles, Grid, Chip, Container, Fab, Button } from '@material-ui/core';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { getRatingMatrix } from 'services/ratings.service';
import { isEmpty } from 'lodash';
import ReactJson from 'react-json-view';
import { HelvNeue } from 'themes/theme';
import { useTrackEvent } from 'util/trackEvent';

const useStyles = makeStyles((theme) => {
  return {
    ratingBoxRoot: {

    },
    ratingChip: {
      margin: theme.spacing(1),
      textTransform: 'capitalize',
      fontFamily: HelvNeue,
      fontWeight: 'normal'
    }
  }
})
const RatingMatrix = ({ subType, rating, onSelect = () => { } }) => {
  const classes = useStyles()

  const trackEvent = useTrackEvent()

  const [ratingMatrix, setRatingMatrix] = useState([]);
  const [baseRatingMatrix, setBaseRatingMatrix] = useState([]);
  const [selectedRatingMatrix, setSelectedRatingMatrix] = useState(new Set());
  const fetchRatingMatrix = useCallback(
    async (subtype) => {
      const results = await getRatingMatrix(subtype)
      setRatingMatrix(results)
      setBaseRatingMatrix(results)
    },
    [],
  );

  useEffect(() => {
    if (isEmpty(subType)) return
    fetchRatingMatrix(subType === 'NURSE' ? 'CLIENT_TO_NURSE' : 'CLIENT_TO_THERAPIST')
  }, [subType]);

  useEffect(() => {
    const filteredMatrix = baseRatingMatrix.filter(item => {
      return item.max >= rating && item.min <= rating
    })
    setSelectedRatingMatrix(new Set())
    setRatingMatrix(filteredMatrix)
    onSelect(filteredMatrix)
  }, [baseRatingMatrix, rating]);

  const addSelectedRating = useCallback(
    (r) => {
      const newMatrix = new Set(selectedRatingMatrix)
      if (newMatrix.has(r)) {
        trackEvent('Rating - rating matrix removed', { rating: r })
        newMatrix.delete(r)
      } else {
        trackEvent('Rating - rating matrix added', { rating: r })
        newMatrix.add(r)
      }
      setSelectedRatingMatrix(newMatrix)
    },
    [selectedRatingMatrix],
  );

  return (
    <Container maxWidth="sm" className={classes.ratingBoxRoot}>
      {ratingMatrix.map((rating, idx) => {
        return (
          <Button size="small"
            variant={selectedRatingMatrix.has(rating) ? 'contained' : 'outlined'}
            className={classes.ratingChip}
            onClick={() => {
              addSelectedRating(rating)
            }}
            color={selectedRatingMatrix.has(rating) ? 'primary' : 'default'}
            key={idx} >{rating?.label}</Button>
        )
      })}
    </Container>
  )
}

export { RatingMatrix }